import makeStyles from '@mui/styles/makeStyles';
import MatchSummaries from "components/Matching/MatchSummaries";
import React from "react";
import HourglassArt from "components/Illustrations/HourglassArt";

const useStyles = makeStyles({
  art: {
    display: 'block',
    width: 300,
    maxWidth: '100%',
    margin: '40px auto 0',
  },
});

const AwaitingResponse = ({matches}) => {
  const classes = useStyles();

  return (
    <div>
      <MatchSummaries matches={matches} infoOnly showExpiryDuration={false} action={'chevron'} avatarSize={40}/>
      <HourglassArt className={classes.art}/>
    </div>
  )
};

export default AwaitingResponse;
